import { render, staticRenderFns } from "./ConsumptionAndWateringChart.vue?vue&type=template&id=81eba164&scoped=true"
import script from "./ConsumptionAndWateringChart.vue?vue&type=script&lang=ts"
export * from "./ConsumptionAndWateringChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eba164",
  null
  
)

export default component.exports